import React from "react";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import axios from "axios";
import { getCookie } from "../jwt/_helpers/cookie";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const SubscriptionTableModal = ({
  openModal,
  setToggleModal,
  values,
  title,
  body,
  apiURL,
  status,
  subID,
}) => {
  const tokenAPI = getCookie("token");

  const { t } = useTranslation();

  const updateData = {
    "id": subID,
    "action": status? "auto_renew": "cancel",
  }

  const statusUpdateBtnColor = (status) ? "success" : "danger";

  const handleUpdate = () => {
    const options = {
      method: "POST",
      data: updateData,
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    };

    axios(`${API_URL}${apiURL}/`, options)
      .then(res => {
        setToggleModal(false);
        values.setSuccess(true);
        values.setForce(values.forceUpdate + 1);
      })
      .catch(err => {
        values.setError(true);
      });
  };
  return (
    <Modal isOpen={openModal} centered={true}>
      <ModalHeader>{title}</ModalHeader>
      {body && <ModalBody>{body}</ModalBody>}

      <ModalFooter>
        <Button color="secondary" onClick={() => setToggleModal(false)}>
          {t("subscription.view.table.modal.button.cancel")}
        </Button>
        <Button color={statusUpdateBtnColor} onClick={() => handleUpdate()}>
          {(status) ? t("subscription.view.table.modal.button.enableAutoRenewal") : t("subscription.view.table.modal.button.cancelSubscription")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SubscriptionTableModal;
